import React from 'react'

export default function RenderValidateMessage(props) {
    const { errors, field } = props;
    const message = errors[field];
    return (
        <div id={`${field}-error`} className="text-danger hide">
            {message}
        </div>
    );
}
